import React from "react";
import DeviceModels from "../modules/DeviceModels/DeviceModels";
export default function DeviceModelsPage() {
  return <DeviceModels />;
}
